import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';

type ToastProps = {
  message: string;
  onClose: () => void;
}

const Toast:React.FC<ToastProps> = ({ message, onClose }) => {
  const [ visible, setVisible ] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    },3000)//3초 후에 토스트가 자동으로 사라지도록 설정

    return () => {
      clearTimeout(timer);
    };
  }, [onClose]); 

  return (
    <ToastContainser visible={visible}>
      <ToastTextWrapper>
        {message}
      </ToastTextWrapper>
    </ToastContainser>
  );
};

export default Toast;

const ToastTextWrapper = styled.div`
  color: rgba(255, 255, 255, 1);
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  align-items: center;
  text-align: center;
  padding: 15px;
  background-color: #A0A0A0;
`;

const fadein = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeout = keyframes`
  from {
    opacity: 1;
  } 
  to {
    opacity: 0;
  }
`
type ToastContainerProps = {
  visible: boolean;
};

const ToastContainser = styled.div<ToastContainerProps>`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-color: rgba(43, 40, 53, 1);
  opacity: 0;
  animation: ${({ visible }) => 
  (visible ? css`${fadein} 0.3s ease-in-out forwards` : css`${fadeout} 0.3s ease-in-out forwards`)};
`;
